export const translations = {
  de: {
    // Header
    title: "PowerPack Verkaufsvertrag",
    subtitle: "mit Zahlungsplan",
    
    // Language selector
    language: "Sprache",
    
    // Progress steps
    steps: {
      role: "Rolle",
      customer: "Kunde",
      product: "Produkt",
      payment: "Zahlungsoptionen",
      terms: "AGB",
      signature: "Unterschrift",
      sendToCustomer: "Senden",
      reservation: "Reservierung"
    },
    
    // Role Selection
    roleSelection: {
      title: "Wer füllt dieses Formular aus?",
      description: "Bitte wählen Sie Ihre Rolle, um fortzufahren.",
      customer: "Kunde",
      customerDescription: "Ich bin der Kunde und möchte den Vertrag selbst ausfüllen und unterschreiben.",
      salesAgent: "Vertriebsmitarbeiter",
      salesAgentDescription: "Ich bin ein RenewBee-Vertriebsmitarbeiter und fülle den Vertrag im Namen des Kunden aus.",
      customerSelected: "Als Kunde fortfahren",
      customerFlow: "Sie werden das gesamte Formular ausfüllen und am Ende digital unterschreiben.",
      salesAgentSelected: "Als Vertriebsmitarbeiter fortfahren",
      salesAgentFlow: "Sie füllen die Vertragsdetails aus und senden den Vertrag zur Unterschrift an den Kunden.",
      passwordTitle: "Mitarbeiter-Zugang",
      passwordDescription: "Bitte geben Sie das Vertriebsmitarbeiter-Passwort ein, um fortzufahren.",
      passwordPlaceholder: "Passwort eingeben",
      passwordSubmit: "Bestätigen",
      passwordCancel: "Abbrechen",
      passwordError: "Falsches Passwort. Bitte versuchen Sie es erneut.",
      passwordProtected: "Passwortgeschützt"
    },
    
    // Send to Customer (Sales Agent flow)
    sendToCustomer: {
      title: "Vertrag an Kunde senden",
      description: "Der Vertrag wird zur Überprüfung und Unterschrift an den Kunden gesendet.",
      summaryTitle: "Vertragsübersicht",
      emailLabel: "E-Mail-Adresse des Kunden",
      emailPlaceholder: "kunde@beispiel.de",
      emailHint: "Der Kunde erhält einen Link zur Überprüfung und Unterschrift des Vertrags.",
      messageLabel: "Persönliche Nachricht (optional)",
      messagePlaceholder: "Fügen Sie eine persönliche Nachricht für den Kunden hinzu...",
      whatHappens: "Was passiert als nächstes?",
      step1: "Der Kunde erhält eine E-Mail mit einem Link zum Vertrag.",
      step2: "Der Kunde überprüft alle Details und die Geschäftsbedingungen.",
      step3: "Der Kunde unterschreibt digital und beide Parteien erhalten eine PDF-Kopie.",
      sendButton: "Vertrag an Kunde senden",
      sending: "Wird gesendet...",
      sentTitle: "Vertrag erfolgreich gesendet!",
      sentMessage: "Der Kunde wurde per E-Mail benachrichtigt und kann den Vertrag nun überprüfen und unterschreiben.",
      sentNote: "Sie erhalten eine Benachrichtigung, sobald der Kunde den Vertrag unterschrieben hat."
    },
    
    // Payment Plan Option
    paymentPlanOption: {
      title: "Zahlungsplan erforderlich?",
      description: "Möchten Sie den Kaufpreis in Raten zahlen?",
      yes: "Ja, Zahlungsplan nutzen",
      no: "Nein, Vollzahlung",
      yesDescription: "Zahlung in 3 Raten (50%, 25%, 25%)",
      noDescription: "Gesamtbetrag bei Vertragsunterzeichnung"
    },
    
    // Reservation Payment
    reservation: {
      title: "Reservierungsgebühr",
      description: "Zur verbindlichen Reservierung Ihrer PowerPack(s) ist eine Anzahlung erforderlich.",
      feeLabel: "Anzahlung / Reservierungsgebühr",
      vatNote: "zzgl. ggf. gesetzlicher Umsatzsteuer",
      termsTitle: "Reservierungsgebühr für PowerPack(s)",
      terms: {
        section1Title: "Reservierungsgebühr",
        section1Content: "Zur verbindlichen Reservierung ihrer PowerPack(s) erhebt die RenewBee GmbH vom Kunden eine Anzahlung (Reservierungsgebühr) in Höhe von 1.000,00 € (zzgl. ggf. gesetzlicher Umsatzsteuer). Mit Zahlung der Anzahlung wird das ausgewählte System für den Kunden exklusiv reserviert.",
        section2Title: "Mitwirkungspflichten des Kunden / Finanzierungsunterlagen",
        section2Content: "Der Kunde verpflichtet sich, innerhalb eines Zeitraums von 1 Monat ab Zahlungseingang die Finanzierung des Projekts aktiv zu betreiben und sämtliche für die Finanzierungsprüfung erforderlichen Unterlagen vollständig, korrekt und fristgerecht einzureichen. Zu den erforderlichen Unterlagen zählen insbesondere, jedoch nicht abschließend:",
        section2List: [
          "eine Selbstauskunft",
          "eine Vermögensaufstellung",
          "Jahresabschlüsse / Bilanzen",
          "betriebswirtschaftliche Auswertungen (BWA)",
          "sowie weitere bankübliche Unterlagen, die im Rahmen der Finanzierungsprüfung erforderlich sind"
        ],
        section2Note: "Unterlagen gelten nur dann als eingereicht, wenn sie vollständig, plausibel und zur Weiterleitung an die finanzierende(n) Bank(en) geeignet sind.",
        section3Title: "Verfall der Anzahlung",
        section3Content: "Kommt der Kunde seinen Mitwirkungspflichten gemäß Absatz (2) ganz oder teilweise nicht oder nicht fristgerecht nach, verfällt die Anzahlung nach Ablauf der vorgenannten Frist von einem (1) Monat. Auf schriftlichen Antrag des Kunden kann eine angemessene Fristverlängerung gewährt werden, sofern hierfür objektiv nachvollziehbare und sachlich begründete Gründe vorliegen.",
        section4Title: "Rückerstattung bei Finanzierungsablehnung trotz ordnungsgemäßer Mitwirkung",
        section4Content: "Die Anzahlung wird dem Kunden vollständig zurückerstattet, sofern der Kunde alle angeforderten Unterlagen gemäß Absatz (2) vollständig, korrekt und fristgerecht eingereicht hat und eine Finanzierung trotz dieser aktiven Mitwirkung durch die angefragte(n) Bank(en) endgültig abgelehnt wird. Die Finanzierungsablehnung ist durch einen geeigneten Nachweis (z. B. schriftliche Ablehnung der finanzierenden Bank) zu belegen. Die Rückerstattung erfolgt innerhalb von 14 Tagen nach Vorlage des Nachweises.",
        section5Title: "Anrechnung auf den Kaufpreis",
        section5Content: "Kommt es zu einem erfolgreichen Vertragsabschluss, wird die geleistete Anzahlung vollständig auf den Kaufpreis der PowerPack(s) angerechnet."
      },
      acceptTerms: "Ich habe die Bedingungen zur Reservierungsgebühr gelesen und akzeptiere diese.",
      payButton: "Jetzt bezahlen",
      processing: "Wird verarbeitet...",
      infoNote: "Sie werden weitergeleitet, um die Zahlung sicher abzuschließen. Die Reservierungsgebühr wird bei erfolgreichem Vertragsabschluss auf den Kaufpreis angerechnet.",
      successTitle: "Zahlung erfolgreich!",
      successMessage: "Ihre Reservierungsgebühr wurde erfolgreich bezahlt. Ihr PowerPack ist nun für Sie reserviert.",
      paid: "bezahlt",
      confirmationNote: "Eine Bestätigung wurde an Ihre E-Mail-Adresse gesendet.",
      processingTitle: "Zahlung wird verarbeitet...",
      processingMessage: "Bitte warten Sie, während wir Ihre Zahlung überprüfen."
    },
    
    // Customer Information Section
    customerInfo: {
      title: "Kontakt- und Kundeninformationen",
      salutation: "Anrede",
      mrs: "Frau",
      mr: "Herr",
      customerNumber: "Kundennr.",
      customerNumberPlaceholder: "z.B. KD-12345",
      name: "Name",
      namePlaceholder: "Vor- und Nachname",
      companyName: "Firmenname",
      companyNamePlaceholder: "Firmenname (optional)",
      commercialRegister: "Handelsregisternummer",
      commercialRegisterPlaceholder: "z.B. HRB 123456",
      vatId: "Ust-IdNr.",
      vatIdPlaceholder: "z.B. DE123456789",
      address: "Anschrift",
      addressPlaceholder: "Straße, PLZ, Stadt",
      phone: "Telefon",
      phonePlaceholder: "+49 xxx xxxxxxx",
      email: "E-Mail",
      emailPlaceholder: "ihre@email.de"
    },
    
    // Product Details Section
    productDetails: {
      title: "Produktdetails",
      productName: "Produktname",
      productNameValue: "RenewBee PowerPack",
      quantity: "Anzahl der PowerPacks",
      quantityPlaceholder: "Anzahl eingeben",
      unitPrice: "Stückpreis",
      unitPriceValue: "58.500,00 €",
      vatNote: "+19% MwSt pro Stück",
      components: "Komponenten (jeweils für 1 PowerPack)",
      componentsList: [
        "2 Batteriemodule",
        "Zellentyp: LFP71173207/314Ah (3.2V/314Ah)"
      ],
      calculations: {
        netPrice: "Preis (netto)",
        vat: "19% MwSt",
        totalPrice: "Gesamtpreis"
      }
    },
    
    // Payment Plan Section
    paymentPlan: {
      title: "Zahlungsplan",
      description: "Der Kaufpreis ist in drei Raten zahlbar:",
      payments: [
        {
          title: "Erste Zahlung",
          percentage: "50%",
          description: "des Gesamtkaufpreises bei Vertragsunterzeichnung fällig. Die Rechnung wird unmittelbar nach Vertragsunterzeichnung ausgestellt."
        },
        {
          title: "Zweite Zahlung",
          percentage: "25%",
          description: "des Gesamtkaufpreises bei Ankunft der Batterien in Deutschland fällig. Die Rechnung wird bei Erreichen dieses Meilensteins ausgestellt."
        },
        {
          title: "Dritte Zahlung",
          percentage: "25%",
          description: "des Gesamtkaufpreises bei Abschluss der Installation und Inbetriebnahme fällig. Die Rechnung wird bei Erreichen dieses Meilensteins ausgestellt."
        }
      ],
      notes: {
        title: "Hinweise",
        items: [
          "Alle Zahlungen sind in EUR per Banküberweisung gemäß den Angaben auf der Rechnung zu leisten.",
          "RenewBee wird sich bemühen, den Kunden mindestens sieben (7) Tage im Voraus vor der Ausstellung von Rechnungen für die zweite und dritte Zahlung zu informieren.",
          "Verspätete Zahlungen können gemäß den Bedingungen dieses Kaufvertrags zusätzliche Kosten verursachen."
        ]
      }
    },
    
    // Terms Section
    terms: {
      title: "Geschäftsbedingungen",
      intro: "Die beigefügten Geschäftsbedingungen sind Bestandteil dieses Kaufvertrags.",
      acceptance: "Mit der Unterzeichnung dieses Vertrags erkennt der Käufer die beigefügten Geschäftsbedingungen an und stimmt diesen zu.",
      checkbox: "Ich habe die Geschäftsbedingungen gelesen und akzeptiere diese.",
      viewTerms: "Geschäftsbedingungen anzeigen",
      introduction: {
        title: "Einführung und Produktübersicht",
        content: "Willkommen bei der RenewBee GmbH, Ihrem zuverlässigen Partner bei der Entwicklung erneuerbarer Energien. Wir von RenewBee laden alle Personen ein, die Teil der grünen Energierevolution sein wollen. Unsere Plattform bietet eine einzigartige Möglichkeit, Solarmodule und Batterieelemente (PowerPacks) zu erwerben.\n\nRenewBee ist bestrebt, erstklassige Solarmodule und Batterieelemente zu liefern. Unsere Batterien werden mit einer umfassenden 10-Jahres-Garantie geliefert, die eine robuste und zuverlässige Energiespeicherung gewährleistet. Darüber hinaus bieten unsere Solarmodule eine beeindruckende 30-Jahres-Garantie, die unser Engagement für langlebige, leistungsstarke Lösungen unterstreicht.\n\nDiese Bedingungen gelten ausdrücklich nur für Geschäftskunden (B2B). Privatkunden (B2C) unterliegen abweichenden Regelungen, die gesondert vereinbart werden müssen."
      },
      sections: {
        purchase: {
          title: "1. Kaufoptionen",
          content: "1.1 Versand an die Adresse des Kunden:\n1.1.1 Kunden, die eine Lieferung an ihre Adresse wünschen, müssen beachten, dass die Versandkosten nicht im Kaufpreis enthalten sind.\n1.1.2 RenewBee wird den Versand im Namen des Kunden erleichtern, und der Kunde ist für die damit verbundenen Versandkosten verantwortlich.\n1.1.3 Die Versanddaten des Kunden müssen korrekt sein und zum Zeitpunkt des Kaufs angegeben werden.\n\n1.2 Wichtige Überlegungen:\n1.2.1 Die Kunden müssen die gewählte Versandoption zum Zeitpunkt des Kaufs angeben.\n1.2.2 Versandkosten fallen zusätzlich an und werden dem Kunden gesondert mitgeteilt.\n1.2.3 RenewBee behält sich das Recht vor, die Versandkosten je nach Standort und anderen relevanten Faktoren anzupassen.\n\n1.3 Eigentumsübergang:\n1.3.1 Der Eigentums- und Gefahrenübergang der PowerPacks von RenewBee GmbH auf den Kunden erfolgt mit Abschluss des Kaufvertrags und Zahlung des Kaufpreises."
        },
        cancellation: {
          title: "2. Annullierungen",
          content: "2.1 Recht auf Widerruf:\n2.1.1 Dem Kunden wird das Recht eingeräumt, den Kauf innerhalb von 14 Tagen nach Zustimmung zu diesen Bedingungen zu widerrufen.\n2.1.2 Um sein Widerrufsrecht auszuüben, muss der Kunde innerhalb der genannten Frist von 14 Tagen eine schriftliche Widerrufserklärung per E-Mail an customer@renewbee.co senden. Der Betreff der E-Mail muss \"Stornierung\" enthalten.\n\n2.2 Entschädigung bei Stornierung:\n2.2.1 Im Falle einer vereinbarten Stornierung verpflichtet sich der Kunde, RenewBee vollständig für alle bis zum Zeitpunkt der Stornierung entstandenen Kosten zu entschädigen.\n2.2.2 Zu den erstattungsfähigen Kosten gehören unter anderem die Kosten für die Produktvorbereitung, die Verpackung und alle bis zum Zeitpunkt der Stornierung erbrachten Dienstleistungen.\n\n2.3 Annullierungsverfahren:\n2.3.1 Stornierungsanfragen müssen schriftlich per E-Mail an customer@renewbee.co mit dem Betreff \"Stornierung\" eingereicht werden.\n2.3.2 Nach Erhalt einer gültigen Stornierungsanfrage wird RenewBee gegebenenfalls Anweisungen für das Rückgabeverfahren bereitstellen.\n\n2.4 Rückgabe von Produkten:\n2.4.1 Wenn die Stornierung die Rücksendung von physischen Produkten beinhaltet, ist der Kunde für die Rücksendung der Artikel in ihrem ursprünglichen Zustand und die damit verbundenen Versandkosten verantwortlich.\n\n2.5 Erstattungsverfahren:\n2.5.1 Nach zufriedenstellendem Abschluss des Stornierungsprozesses wird RenewBee eine Rückerstattung des Kaufbetrags abzüglich der bis zum Zeitpunkt der Stornierung angefallenen Kosten veranlassen.\n2.5.2 Erstattungen werden gemäß den Standard-Erstattungsverfahren von RenewBee bearbeitet.\n\n2.6 Ausnahmen von der Stornierung:\n2.6.1 Bestimmte Produkte oder Dienstleistungen können nach geltendem Recht vom Widerrufsrecht ausgenommen sein.\n2.6.2 RenewBee behält sich das Recht vor, Stornierungen für Produkte oder Dienstleistungen, die unter diese Ausnahmen fallen, abzulehnen.\n\n2.7 Änderung der Kündigungsbedingungen:\n2.7.1 RenewBee behält sich das Recht vor, die Bedingungen für die Stornierung zu ändern.\n2.7.2 Alle Änderungen werden dem Kunden per E-Mail mitgeteilt und gelten ab sofort.\n\n2.8 Datum des Inkrafttretens:\n2.8.1 Diese Stornobedingungen sind ab dem Datum der Annahme dieser Bedingungen durch den Kunden wirksam."
        },
        pricing: {
          title: "3. Preisgestaltung",
          content: "3.1 Differenzierung der Preisgestaltung:\n3.1.1 Die Preise für das PowerPack sind von Standort zu Standort unterschiedlich und richten sich nach der Anzahl der Solarmodule und Batterieelemente.\n3.1.2 Die spezifischen Preise für jeden Standort werden dem Kunden während des Kaufvorgangs mitgeteilt und hängen von der vom Kunden gewählten Konfiguration ab.\n3.1.3 Detaillierte Preisinformationen werden in der Rechnung, die diesen Bedingungen beigefügt ist, aufgeführt.\n\n3.2 Gültigkeitsdauer:\n3.2.1 Die angegebenen Preise gelten für einen Zeitraum von 14 Tagen ab dem Datum des ersten Angebots.\n3.2.2 Während dieser 14-tägigen Frist ist der Kunde berechtigt, den angebotenen Preis für die angegebene Konfiguration zu akzeptieren.\n\n3.3 Recht auf Änderung der Preisgestaltung:\n3.3.1 RenewBee behält sich das Recht vor, die Preise für das PowerPack nach Ablauf der 14-tägigen Gültigkeitsdauer zu ändern.\n3.3.2 Etwaige Änderungen der Preise werden dem Kunden schriftlich mitgeteilt.\n\n3.4 Akzeptanz von Preisänderungen:\n3.4.1 Im Falle einer Preisänderung nach Ablauf der 14-tägigen Gültigkeitsdauer hat der Kunde die Möglichkeit, die geänderten Preise zu akzeptieren oder den Kauf zu stornieren.\n3.4.2 Entscheidet sich der Kunde, den Kauf aufgrund einer Preisänderung zu stornieren, so gelten die in Abschnitt 2 genannten Stornierungsbedingungen.\n\n3.5 Details der Rechnung:\n3.5.1 Die detaillierten Preise, einschließlich aller anfallenden Steuern und Gebühren, werden in der Rechnung, die diesen Bedingungen beiliegt, deutlich angegeben.\n3.5.2 Die Rechnung dient als umfassende Aufschlüsselung der mit der gewählten PowerPack-Konfiguration verbundenen Kosten.\n\n3.6 Änderung der Preiskonditionen:\n3.6.1 RenewBee behält sich das Recht vor, die Bedingungen für die Preisgestaltung zu ändern.\n3.6.2 Etwaige Änderungen werden dem Kunden schriftlich mitgeteilt und gelten mit Wirkung für die Zukunft.\n\n3.7 Datum des Inkrafttretens:\n3.7.1 Diese Preisbedingungen gelten ab dem Datum der Annahme dieser Bedingungen durch den Kunden."
        },
        provision: {
          title: "4. Bereitstellung der PowerPacks",
          content: "4.1 Es wird erwartet, dass die PowerPacks, bestehend aus einem Container mit Solarmodulen und Batterieelementen (z. B. ein 30-Tonnen-BESS), von RenewBee GmbH innerhalb von etwa 6-8 Wochen (Solarmodule) bzw. etwa 16 Wochen (Batterien) nach Vertragsabschluss an einem von RenewBee GmbH in Deutschland betriebenen Standort bereitgestellt werden, der dem Kunden bei Vertragsabschluss schriftlich mitgeteilt wird.\n\n4.2 Der Kunde bestätigt, dass ihm bekannt ist, dass RenewBee GmbH Beratungs- und Managementdienstleistungen für die PowerPacks zur Optimierung der Nutzung anbietet.\n\n4.3 Bis zur Bereitstellung trägt RenewBee GmbH das Risiko für Verlust oder Beschädigung der PowerPacks.\n\n4.4 Unvorhergesehene Verzögerungen im Bereitstellungsprozess werden dem Kunden unverzüglich mitgeteilt, zusammen mit einem geänderten Zeitplan.\n\n4.5 Mit dem Kauf erkennt der Kunde die in diesem Abschnitt genannten Bereitstellungsfristen als unverbindliche Schätzungen an und akzeptiert sie.\n\n4.6 RenewBee behält sich das Recht vor, die Bedingungen für die Bereitstellung zu ändern, wobei Änderungen dem Kunden schriftlich mitgeteilt werden und mit Wirkung für die Zukunft gelten.\n\n4.7 Datum des Inkrafttretens:\n4.7.1 Diese Bereitstellungsbedingungen gelten ab dem Datum der Annahme dieser Bedingungen durch den Kunden."
        },
        warranty: {
          title: "5. Garantie",
          content: "5.1 Produktgarantien:\n5.1.1 Alle PowerPacks bestehen aus neuen Solarmodulen und Batterien, für die jeweils eine Werksgarantie gilt.\n5.1.2 Für Solarmodule gilt eine Werksgarantie von 30 Jahren.\n5.1.3 Für die Batterien gilt eine Werksgarantie von 10 Jahren.\n\n5.2 Garantieleistungen:\n5.2.1 Eine Gerätegarantie schützt vor Herstellerfehlern und unerwarteten Schäden an den Komponenten.\n5.2.2 Eine Effizienzgarantie sieht eine maximale Degradationsrate pro Jahr vor.\n\n5.3 Gewährleistungsansprüche:\n5.3.1 Im Falle eines Garantieanspruchs wird RenewBee alle notwendigen Ansprüche im Namen des Kunden verwalten.\n5.3.2 RenewBee wird Gewährleistungsansprüche im Zusammenhang mit Material- oder Verarbeitungsfehlern unverzüglich bearbeiten.\n\n5.4 Ausschlüsse von der Garantie:\n5.4.1 Die Garantie erstreckt sich nicht auf Schäden, die durch Missbrauch, Fahrlässigkeit, Unfälle oder unbefugte Änderungen entstanden sind.\n5.4.2 Normale Abnutzung und Verschleiß sind nicht von der Garantie abgedeckt.\n\n5.5 Änderung der Gewährleistungsbedingungen:\n5.5.1 RenewBee behält sich das Recht vor, die Garantiebedingungen zu ändern.\n5.5.2 Änderungen werden dem Kunden schriftlich mitgeteilt und gelten mit Wirkung für die Zukunft.\n\n5.6 Datum des Inkrafttretens:\n5.6.1 Diese Garantiebedingungen gelten ab dem Datum der Annahme dieser Bedingungen durch den Kunden."
        },
        liability: {
          title: "6. Haftung",
          content: "6.1 Haftungsbeschränkung:\n6.1.1 RenewBee haftet nicht für Schäden oder Verluste der PowerPacks nach Bereitstellung gemäß Abschnitt 4.\n\n6.2 Ausschluss stillschweigender Garantien:\n6.2.1 RenewBee lehnt alle stillschweigenden Garantien ab, einschließlich der Marktgängigkeit und Eignung für einen bestimmten Zweck.\n6.2.2 Der Kunde akzeptiert die PowerPacks auf einer \"as-is\"-Basis zum Zeitpunkt der Bereitstellung.\n\n6.3 Maximale Haftungsbeschränkung:\n6.3.1 Die Gesamthaftung von RenewBee übersteigt in keinem Fall den Gesamtbetrag, den der Kunde für die PowerPacks bezahlt hat.\n\n6.4 Änderung der Haftungsbedingungen:\n6.4.1 RenewBee behält sich das Recht vor, die Haftungsbedingungen zu ändern.\n6.4.2 Etwaige Änderungen werden dem Kunden schriftlich mitgeteilt und gelten mit Wirkung für die Zukunft.\n\n6.5 Datum des Inkrafttretens:\n6.5.1 Diese Haftungsbedingungen gelten ab dem Datum der Annahme dieser Bedingungen durch den Kunden."
        }
      }
    },
    
    // Signature Section
    signature: {
      title: "Unterschrift",
      instruction: "Bitte füllen Sie die folgenden Felder aus und unterschreiben Sie den Vertrag.",
      name: "Name",
      namePlaceholder: "Vollständiger Name",
      companyName: "Firmenname",
      companyNamePlaceholder: "Firmenname",
      location: "Ort",
      locationPlaceholder: "Stadt",
      date: "Datum",
      signatureLabel: "Unterschrift",
      signatureMode: {
        draw: "Zeichnen",
        type: "Tippen"
      },
      drawInstruction: "Bitte unterschreiben Sie im Feld unten",
      typeInstruction: "Geben Sie Ihren Namen als digitale Unterschrift ein",
      typePlaceholder: "Geben Sie Ihren vollständigen Namen ein",
      clear: "Löschen",
      emailConfirmation: "E-Mail für PDF-Bestätigung",
      emailPlaceholder: "ihre@email.de"
    },
    
    // Buttons
    buttons: {
      next: "Weiter",
      previous: "Zurück",
      submit: "Vertrag absenden",
      submitting: "Wird gesendet..."
    },
    
    // Success Message
    success: {
      title: "Vertrag erfolgreich eingereicht!",
      message: "Vielen Dank für Ihre Bestellung. Eine PDF-Kopie des Vertrags wird an Ihre E-Mail-Adresse gesendet.",
      emailSent: "E-Mail gesendet an:",
      downloadPdf: "PDF herunterladen",
      newContract: "Neuen Vertrag erstellen"
    },
    
    // Validation Messages
    validation: {
      required: "Dieses Feld ist erforderlich",
      invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      invalidPhone: "Bitte geben Sie eine gültige Telefonnummer ein",
      minQuantity: "Mindestmenge ist 0.5",
      termsRequired: "Sie müssen die Geschäftsbedingungen akzeptieren",
      signatureRequired: "Bitte unterschreiben Sie den Vertrag"
    },
    
    // Footer
    footer: {
      company: "RenewBee GmbH",
      address: "Uhlandstraße 165/166, 10719 Berlin, Deutschland",
      commercialRegister: "Handelsregisternummer: HRB 260515 B",
      taxNumber: "Steuernummer: 27/490/50646",
      vatId: "Ust-IdNr: DE369471524"
    }
  },
  
  en: {
    // Header
    title: "PowerPack Sales Contract",
    subtitle: "with Payment Plan",
    
    // Language selector
    language: "Language",
    
    // Progress steps
    steps: {
      role: "Role",
      customer: "Customer",
      product: "Product",
      payment: "Payment Options",
      terms: "T&C",
      signature: "Signature",
      sendToCustomer: "Send",
      reservation: "Reservation"
    },
    
    // Role Selection
    roleSelection: {
      title: "Who is completing this form?",
      description: "Please select your role to continue.",
      customer: "Customer",
      customerDescription: "I am the customer and want to fill out and sign the contract myself.",
      salesAgent: "Sales Agent",
      salesAgentDescription: "I am a RenewBee sales agent filling out the contract on behalf of the customer.",
      customerSelected: "Continue as Customer",
      customerFlow: "You will complete the entire form and digitally sign at the end.",
      salesAgentSelected: "Continue as Sales Agent",
      salesAgentFlow: "You will fill in the contract details and send it to the customer for signature.",
      passwordTitle: "Staff Access",
      passwordDescription: "Please enter the sales agent password to continue.",
      passwordPlaceholder: "Enter password",
      passwordSubmit: "Confirm",
      passwordCancel: "Cancel",
      passwordError: "Incorrect password. Please try again.",
      passwordProtected: "Password protected"
    },
    
    // Send to Customer (Sales Agent flow)
    sendToCustomer: {
      title: "Send Contract to Customer",
      description: "The contract will be sent to the customer for review and signature.",
      summaryTitle: "Contract Summary",
      emailLabel: "Customer Email Address",
      emailPlaceholder: "customer@example.com",
      emailHint: "The customer will receive a link to review and sign the contract.",
      messageLabel: "Personal Message (optional)",
      messagePlaceholder: "Add a personal message for the customer...",
      whatHappens: "What happens next?",
      step1: "The customer receives an email with a link to the contract.",
      step2: "The customer reviews all details and the terms & conditions.",
      step3: "The customer signs digitally and both parties receive a PDF copy.",
      sendButton: "Send Contract to Customer",
      sending: "Sending...",
      sentTitle: "Contract Successfully Sent!",
      sentMessage: "The customer has been notified via email and can now review and sign the contract.",
      sentNote: "You will receive a notification once the customer has signed the contract."
    },
    
    // Reservation Payment
    reservation: {
      title: "Reservation Fee",
      description: "A deposit is required for the binding reservation of your PowerPack(s).",
      feeLabel: "Deposit / Reservation Fee",
      vatNote: "plus applicable VAT if required",
      termsTitle: "Reservation Fee for PowerPack(s)",
      terms: {
        section1Title: "Reservation Fee",
        section1Content: "For the binding reservation of their PowerPack(s), RenewBee GmbH charges the customer a deposit (reservation fee) of €1,000.00 (plus applicable VAT if required). Upon payment of the deposit, the selected system is exclusively reserved for the customer.",
        section2Title: "Customer Cooperation Obligations / Financing Documents",
        section2Content: "The customer undertakes to actively pursue the financing of the project within a period of 1 month from receipt of payment and to submit all documents required for the financing review completely, correctly and on time. The required documents include, but are not limited to:",
        section2List: [
          "a self-assessment form",
          "a statement of assets",
          "annual financial statements / balance sheets",
          "business analysis reports (BWA)",
          "and other standard banking documents required for the financing review"
        ],
        section2Note: "Documents are only considered submitted if they are complete, plausible and suitable for forwarding to the financing bank(s).",
        section3Title: "Forfeiture of the Deposit",
        section3Content: "If the customer fails to comply with their cooperation obligations in accordance with paragraph (2) in whole or in part, or fails to do so on time, the deposit shall be forfeited after expiry of the aforementioned period of one (1) month. Upon written request from the customer, a reasonable extension may be granted if there are objectively comprehensible and factually justified reasons for this.",
        section4Title: "Refund in Case of Financing Rejection Despite Proper Cooperation",
        section4Content: "The deposit will be refunded to the customer in full if the customer has submitted all requested documents in accordance with paragraph (2) completely, correctly and on time and financing is ultimately rejected by the requested bank(s) despite this active cooperation. The financing rejection must be documented by suitable evidence (e.g., written rejection from the financing bank). The refund will be made within 14 days of submission of proof.",
        section5Title: "Credit Towards Purchase Price",
        section5Content: "If the contract is successfully concluded, the deposit paid will be fully credited towards the purchase price of the PowerPack(s)."
      },
      acceptTerms: "I have read and accept the terms regarding the reservation fee.",
      payButton: "Pay Now",
      processing: "Processing...",
      infoNote: "You will be redirected to securely complete the payment. The reservation fee will be credited to the purchase price upon successful contract conclusion.",
      successTitle: "Payment Successful!",
      successMessage: "Your reservation fee has been successfully paid. Your PowerPack is now reserved for you.",
      paid: "paid",
      confirmationNote: "A confirmation has been sent to your email address.",
      processingTitle: "Processing Payment...",
      processingMessage: "Please wait while we verify your payment."
    },
    
    // Payment Plan Option
    paymentPlanOption: {
      title: "Payment Plan Required?",
      description: "Would you like to pay the purchase price in installments?",
      yes: "Yes, use payment plan",
      no: "No, full payment",
      yesDescription: "Payment in 3 installments (50%, 25%, 25%)",
      noDescription: "Full amount due at contract signing"
    },
    
    // Customer Information Section
    customerInfo: {
      title: "Contact & Customer Information",
      salutation: "Salutation",
      mrs: "Mrs.",
      mr: "Mr.",
      customerNumber: "Customer No.",
      customerNumberPlaceholder: "e.g., KD-12345",
      name: "Name",
      namePlaceholder: "First and last name",
      companyName: "Company Name",
      companyNamePlaceholder: "Company name (optional)",
      commercialRegister: "Commercial Register No.",
      commercialRegisterPlaceholder: "e.g., HRB 123456",
      vatId: "VAT ID",
      vatIdPlaceholder: "e.g., DE123456789",
      address: "Address",
      addressPlaceholder: "Street, Postal Code, City",
      phone: "Phone",
      phonePlaceholder: "+49 xxx xxxxxxx",
      email: "Email",
      emailPlaceholder: "your@email.com"
    },
    
    // Product Details Section
    productDetails: {
      title: "Product Details",
      productName: "Product Name",
      productNameValue: "RenewBee PowerPack",
      quantity: "Number of PowerPacks",
      quantityPlaceholder: "Enter quantity",
      unitPrice: "Unit Price",
      unitPriceValue: "€58,500.00",
      vatNote: "+19% VAT per unit",
      components: "Components (per 1 PowerPack)",
      componentsList: [
        "2 Battery Modules",
        "Cell Type: LFP71173207/314Ah (3.2V/314Ah)"
      ],
      calculations: {
        netPrice: "Price (net)",
        vat: "19% VAT",
        totalPrice: "Total Price"
      }
    },
    
    // Payment Plan Section
    paymentPlan: {
      title: "Payment Plan",
      description: "The purchase price is payable in three installments:",
      payments: [
        {
          title: "First Payment",
          percentage: "50%",
          description: "of the total purchase price is due upon contract signing. The invoice will be issued immediately after contract signing."
        },
        {
          title: "Second Payment",
          percentage: "25%",
          description: "of the total purchase price is due when the batteries arrive in Germany. The invoice will be issued upon reaching this milestone."
        },
        {
          title: "Third Payment",
          percentage: "25%",
          description: "of the total purchase price is due upon completion of installation and commissioning. The invoice will be issued upon reaching this milestone."
        }
      ],
      notes: {
        title: "Notes",
        items: [
          "All payments are to be made in EUR via bank transfer as specified on the invoice.",
          "RenewBee will endeavor to inform the customer at least seven (7) days in advance before issuing invoices for the second and third payments.",
          "Late payments may incur additional costs as per the terms of this purchase agreement."
        ]
      }
    },
    
    // Terms Section
    terms: {
      title: "Terms & Conditions",
      intro: "The attached terms and conditions are an integral part of this purchase agreement.",
      acceptance: "By signing this contract, the buyer acknowledges and agrees to the attached terms and conditions.",
      checkbox: "I have read and accept the terms and conditions.",
      viewTerms: "View Terms & Conditions",
      introduction: {
        title: "Introduction and Product Overview",
        content: "Welcome to RenewBee GmbH, your reliable partner in the development of renewable energy. At RenewBee, we invite all individuals who wish to be part of the green energy revolution. Our platform offers a unique opportunity to acquire solar modules and battery elements (PowerPacks).\n\nRenewBee is committed to delivering first-class solar modules and battery elements. Our batteries come with a comprehensive 10-year warranty, ensuring robust and reliable energy storage. Furthermore, our solar modules offer an impressive 30-year warranty, underscoring our commitment to durable, high-performance solutions.\n\nThese terms explicitly apply to business customers (B2B). Private customers (B2C) are subject to different regulations, which must be agreed upon separately."
      },
      sections: {
        purchase: {
          title: "1. Purchase Options",
          content: "1.1 Delivery to Customer's Address:\n1.1.1 Customers wishing for delivery to their address must note that shipping costs are not included in the purchase price.\n1.1.2 RenewBee will facilitate shipping on behalf of the customer, and the customer is responsible for the associated shipping costs.\n1.1.3 The customer's shipping details must be accurate and provided at the time of purchase.\n\n1.2 Important Considerations:\n1.2.1 Customers must specify their chosen shipping option at the time of purchase.\n1.2.2 Shipping costs are additional and will be communicated to the customer separately.\n1.2.3 RenewBee reserves the right to adjust shipping costs based on location and other relevant factors.\n\n1.3 Transfer of Ownership:\n1.3.1 The transfer of ownership and risk for the PowerPacks from RenewBee GmbH to the customer occurs upon completion of the purchase agreement and payment of the purchase price."
        },
        cancellation: {
          title: "2. Cancellations",
          content: "2.1 Right of Withdrawal:\n2.1.1 The customer is granted the right to withdraw from the purchase within 14 days of agreeing to these terms.\n2.1.2 To exercise their right of withdrawal, the customer must send a written withdrawal declaration via email to customer@renewbee.co within the aforementioned 14-day period. The email subject line must include \"Stornierung\".\n\n2.2 Compensation for Cancellation:\n2.2.1 In the event of an agreed cancellation, the customer undertakes to fully compensate RenewBee for all costs incurred up to the point of cancellation.\n2.2.2 Refundable costs include, but are not limited to, costs for product preparation, packaging, and any services rendered up to the time of cancellation.\n\n2.3 Cancellation Procedure:\n2.3.1 Cancellation requests must be submitted in writing via email to customer@renewbee.co with the subject line \"Stornierung\".\n2.3.2 Upon receipt of a valid cancellation request, RenewBee will provide instructions for the return process if applicable.\n\n2.4 Return of Products:\n2.4.1 If cancellation involves the return of physical products, the customer is responsible for returning the items in their original condition and for the associated shipping costs.\n\n2.5 Refund Procedure:\n2.5.1 Following the satisfactory completion of the cancellation process, RenewBee will arrange for a refund of the purchase amount, less any costs incurred up to the time of cancellation.\n2.5.2 Refunds will be processed according to RenewBee's standard refund procedures.\n\n2.6 Exceptions to Cancellation:\n2.6.1 Certain products or services may be exempt from the right of withdrawal under applicable law.\n2.6.2 RenewBee reserves the right to refuse cancellations for products or services falling under these exceptions.\n\n2.7 Amendment of Cancellation Terms:\n2.7.1 RenewBee reserves the right to amend the terms for cancellation.\n2.7.2 Any changes will be communicated to the customer via email and will be effective immediately.\n\n2.8 Effective Date:\n2.8.1 These cancellation terms are effective from the date of the customer's acceptance of these terms."
        },
        pricing: {
          title: "3. Pricing",
          content: "3.1 Pricing Differentiation:\n3.1.1 Prices for the PowerPack vary from location to location and depend on the number of solar modules and battery elements.\n3.1.2 Specific prices for each location will be communicated to the customer during the purchase process and depend on the configuration chosen by the customer.\n3.1.3 Detailed pricing information will be provided in the invoice attached to these terms.\n\n3.2 Validity Period:\n3.2.1 The quoted prices are valid for a period of 14 days from the date of the initial offer.\n3.2.2 During this 14-day period, the customer is entitled to accept the offered price for the specified configuration.\n\n3.3 Right to Amend Pricing:\n3.3.1 RenewBee reserves the right to change the prices for the PowerPack after the expiration of the 14-day validity period.\n3.3.2 Any price changes will be communicated to the customer in writing.\n\n3.4 Acceptance of Price Changes:\n3.4.1 In the event of a price change after the 14-day validity period, the customer has the option to accept the revised prices or cancel the purchase.\n3.4.2 If the customer chooses to cancel the purchase due to a price change, the cancellation terms outlined in Section 2 will apply.\n\n3.5 Invoice Details:\n3.5.1 Detailed prices, including all applicable taxes and fees, will be clearly stated in the invoice accompanying these terms.\n3.5.2 The invoice will serve as a comprehensive breakdown of the costs associated with the chosen PowerPack configuration.\n\n3.6 Amendment of Pricing Conditions:\n3.6.1 RenewBee reserves the right to amend the pricing conditions.\n3.6.2 Any changes will be communicated to the customer in writing and will be effective for the future.\n\n3.7 Effective Date:\n3.7.1 These pricing terms are effective from the date of the customer's acceptance of these terms."
        },
        provision: {
          title: "4. Provision of PowerPacks",
          content: "4.1 The PowerPacks, consisting of a container with solar modules and battery elements (e.g., a 30-ton BESS), are expected to be provided by RenewBee GmbH within approximately 6-8 weeks (solar modules) or approximately 16 weeks (batteries) after the agreement is concluded, at a location operated by RenewBee GmbH in Germany, which will be communicated to the customer in writing upon agreement.\n\n4.2 The customer confirms awareness that RenewBee GmbH offers consulting and management services for the PowerPacks to optimize their utilization.\n\n4.3 RenewBee GmbH bears the risk of loss or damage to the PowerPacks until they are provided.\n\n4.4 Unforeseen delays in the provision process will be communicated to the customer promptly, along with an updated schedule.\n\n4.5 By purchasing, the customer acknowledges and accepts the provision timelines mentioned in this section as non-binding estimates.\n\n4.6 RenewBee reserves the right to amend the terms for provision, with changes being communicated to the customer in writing and effective for the future.\n\n4.7 Effective Date:\n4.7.1 These provision terms are effective from the date of the customer's acceptance of these terms."
        },
        warranty: {
          title: "5. Warranty",
          content: "5.1 Product Warranties:\n5.1.1 All PowerPacks consist of new solar modules and batteries, each with a manufacturer's warranty.\n5.1.2 Solar modules are covered by a 30-year manufacturer's warranty.\n5.1.3 Batteries are covered by a 10-year manufacturer's warranty.\n\n5.2 Warranty Services:\n5.2.1 A device warranty protects against manufacturing defects and unexpected damage to components.\n5.2.2 An efficiency warranty provides for a maximum degradation rate per year.\n\n5.3 Warranty Claims:\n5.3.1 In the event of a warranty claim, RenewBee will manage all necessary claims on behalf of the customer.\n5.3.2 RenewBee will promptly process warranty claims related to material or manufacturing defects.\n\n5.4 Warranty Exclusions:\n5.4.1 The warranty does not cover damage caused by misuse, negligence, accidents, or unauthorized modifications.\n5.4.2 Normal wear and tear are not covered by the warranty.\n\n5.5 Amendment of Warranty Terms:\n5.5.1 RenewBee reserves the right to amend the warranty terms.\n5.5.2 Any changes will be communicated to the customer in writing and will be effective for the future.\n\n5.6 Effective Date:\n5.6.1 These warranty terms are effective from the date of the customer's acceptance of these terms."
        },
        liability: {
          title: "6. Liability",
          content: "6.1 Limitation of Liability:\n6.1.1 RenewBee is not liable for any damage or loss of the PowerPacks after provision as per Section 4.\n\n6.2 Disclaimer of Implied Warranties:\n6.2.1 RenewBee disclaims all implied warranties, including those of merchantability and fitness for a particular purpose.\n6.2.2 The customer accepts the PowerPacks on an \"as-is\" basis at the time of provision.\n\n6.3 Maximum Liability:\n6.3.1 RenewBee's total liability shall in no event exceed the total amount paid by the customer for the PowerPacks.\n\n6.4 Amendment of Liability Terms:\n6.4.1 RenewBee reserves the right to amend the liability terms.\n6.4.2 Any changes will be communicated to the customer in writing and will be effective for the future.\n\n6.5 Effective Date:\n6.5.1 These liability terms are effective from the date of the customer's acceptance of these terms."
        }
      }
    },
    
    // Signature Section
    signature: {
      title: "Signature",
      instruction: "Please complete the following fields and sign the contract.",
      name: "Name",
      namePlaceholder: "Full name",
      companyName: "Company Name",
      companyNamePlaceholder: "Company name",
      location: "Location",
      locationPlaceholder: "City",
      date: "Date",
      signatureLabel: "Signature",
      signatureMode: {
        draw: "Draw",
        type: "Type"
      },
      drawInstruction: "Please sign in the field below",
      typeInstruction: "Enter your name as a digital signature",
      typePlaceholder: "Enter your full name",
      clear: "Clear",
      emailConfirmation: "Email for PDF confirmation",
      emailPlaceholder: "your@email.com"
    },
    
    // Buttons
    buttons: {
      next: "Next",
      previous: "Previous",
      submit: "Submit Contract",
      submitting: "Submitting..."
    },
    
    // Success Message
    success: {
      title: "Contract Successfully Submitted!",
      message: "Thank you for your order. A PDF copy of the contract will be sent to your email address.",
      emailSent: "Email sent to:",
      downloadPdf: "Download PDF",
      newContract: "Create New Contract"
    },
    
    // Validation Messages
    validation: {
      required: "This field is required",
      invalidEmail: "Please enter a valid email address",
      invalidPhone: "Please enter a valid phone number",
      minQuantity: "Minimum quantity is 0.5",
      termsRequired: "You must accept the terms and conditions",
      signatureRequired: "Please sign the contract"
    },
    
    // Footer
    footer: {
      company: "RenewBee GmbH",
      address: "Uhlandstraße 165/166, 10719 Berlin, Germany",
      commercialRegister: "Commercial Register: HRB 260515 B",
      taxNumber: "Tax Number: 27/490/50646",
      vatId: "VAT ID: DE369471524"
    }
  }
};

export const formatCurrency = (amount, locale = 'de-DE') => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

export const formatDate = (date, locale = 'de-DE') => {
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(date);
};
